import React from 'react';
import Layout from '@/components/Layout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Clock, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

/**
 * ComingSoon - Placeholder page for modules that are not yet available
 */
const ComingSoon = ({ user, onLogout, moduleName = 'Dieses Modul' }) => {
  const navigate = useNavigate();

  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="flex items-center justify-center min-h-[60vh]">
        <Card className="max-w-md text-center">
          <CardHeader>
            <div className="mx-auto w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-4">
              <Clock className="w-8 h-8 text-muted-foreground" />
            </div>
            <CardTitle className="text-2xl">{moduleName}</CardTitle>
            <CardDescription className="text-lg">
              Kommt bald!
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-muted-foreground">
              Wir arbeiten aktiv an diesem Modul. Es wird in Kürze verfügbar sein.
            </p>
            <Button variant="outline" onClick={() => navigate(-1)}>
              <ArrowLeft className="w-4 h-4 mr-2" />
              Zurück
            </Button>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default ComingSoon;
